import { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import apiClient from "../../../apiClient";

export default function SprintPass({
    activeTab
}) {

    const [data, setData] = useState([]);

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await apiClient.get(`/dev/sprintpass`);
                setData(res.data);
            } catch (err) { }
        }
        if (activeTab === 'sprintpass') {
            getData();
        }
    }, [activeTab]);

    return (
        <div>
            <h6>SprintPass API Results</h6>
            <ReactJson src={data} displayDataTypes={false} />
        </div>
    );
}